<template>
  <v-blacker-layout
    align-center
    column
  >
    <strong :class="titleClass">
      {{ title }}
    </strong>
    <v-blacker-layout
      v-if="noData"
      class="vbt-margin-t-5"
      justify-center
    >
      {{ noDataText }}
    </v-blacker-layout>
    <ve-pie
      v-else
      :data="chartData"
      :settings="chartSettings"
      :legend-visible="false"
      :text-style="textStyle"
      style="margin: -40px 0 -30px 0;"
      width="100%"
    />
  </v-blacker-layout>
</template>

<script>
export default {
  name: 'PrintedQuantityPieChart',
  props: {
    title: {
      type: String,
      default: '',
    },
    noDataText: {
      type: String,
      default: 'No data',
    },
    chartData: {
      type: Object,
      default: () => ({ columns: [], rows: [] }),
      validator: value => ['columns', 'rows'].every(field => Array.isArray(value[field])),
    },
    chartSettings: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    noData() {
      return !this.chartData.rows.length;
    },
    textStyle() {
      return { color: this.$vuetify.theme.dark ? '#fff' : '#000' };
    },
    titleClass() {
      return { 'white--text': this.$vuetify.theme.dark };
    },
  },
};
</script>
